import useThemeClassName from "@casino/legacy/client/hooks/theme/useThemeClassName";
import { cn } from "@workspace/frontend-ui";

type Props = {
  colorScheme: "light" | "dark";
  className?: string;
};

const TailwindThemeProvider: FC<Props> = ({
  children,
  colorScheme,
  className,
}) => {
  const themeClassName = useThemeClassName(colorScheme);

  return <div className={cn(themeClassName, className)}>{children}</div>;
};

export default TailwindThemeProvider;
